import { create } from 'zustand';

export type CelebrationType = 'none' | 'rank1' | 'rank2' | 'rank3';

interface CelebrationStore {
  // Current celebration state
  activeCelebration: CelebrationType;

  // Actions
  checkAndTriggerCelebration: (rank: number | null) => CelebrationType;
  clearCelebration: () => void;
}

export const useCelebrationStore = create<CelebrationStore>()((set) => ({
  activeCelebration: 'none',

  checkAndTriggerCelebration: (rank: number | null) => {
    let celebration: CelebrationType = 'none';

    if (rank === 1) {
      celebration = 'rank1';
    } else if (rank === 2) {
      celebration = 'rank2';
    } else if (rank === 3) {
      celebration = 'rank3';
    }

    set({ activeCelebration: celebration });
    return celebration;
  },

  clearCelebration: () => set({ activeCelebration: 'none' }),
}));
